export default {
  common: {
    readMore: 'View All',
    contactUs: 'Contact Us',
    getInTouch: 'Get in Touch',
    sendInquiry: 'Send Inquiry',
    back: 'Back',
    backToNews: 'Back to News',
    backToNewsList: 'Back to News List',
    clearSearch: 'Clear Search',
    search: 'Search',
    noResults: 'No results found',
    required: 'Required',
    submit: 'Submit',
    submitting: 'Submitting...',
    showing: 'Showing',
    of: 'of',
    products: 'products',
    all: 'All',
  },
};
